import {useDispatch, useSelector} from 'react-redux';
import { TextField  } from '@rmwc/textfield';
import { updatePriceCalculation } from '../../action/building_pricing/buildingPricing.action.js';
import CurrencyFormat from 'react-currency-format';

function normalizeKey(str) {
  return str == '' ? str : str
    .normalize('NFKD')                // Normalize Unicode (e.g. accented characters)
    .replace(/[’‘']/g, "/")           // Replace all types of apostrophes with slash
    .replace(/\s+/g, '')              // Remove all spaces
    .toLowerCase();                   // Convert to lowercase
}

const EditPriceItem = (props) => {
  const const_var = useSelector(state => state.reducer.const_var)
  const dispatch = useDispatch()

  let UpdatedPrice = 0;

  if((props.jsonObj=="extraitems" || props.jsonObj=="extraAddOnItems") && props.updatedPriceDataObj && const_var.isLTBuilding) {
    const newObj = {}
    Object.keys(props.updatedPriceDataObj).forEach(key => {
      const cleanedKey = normalizeKey(key);
      newObj[cleanedKey] = props.updatedPriceDataObj[key]
    })
    UpdatedPrice = newObj[normalizeKey(props.jsonObjKey)]?.item_price;
  } else if(props.jsonObj=="extraAddOnItems" && const_var.UpdatedPriceData?.['elements']?.[props.jsonObjKey]==undefined) {
    UpdatedPrice = 0;
  } else if(props.jsonObj === "extraAddOnItems" && const_var?.UpdatedPriceData?.elements?.[props.jsonObjKey] !== undefined) {
    UpdatedPrice = const_var.UpdatedPriceData.elements[props.jsonObjKey]?.item_price;
  } else if(props.jsonObj=="extraitems" && const_var.UpdatedPriceData?.['elements']?.[props.jsonObjKey]==undefined) {
    if(props.jsonObjKey == "Side Cross Bracing" || props.jsonObjKey == "End Cross Bracing"){
      let findBracingObj = Object.keys(const_var.UpdatedPriceData?.['elements']).find(key => const_var.UpdatedPriceData?.['elements'][key]?.other_item_name && const_var.UpdatedPriceData?.['elements'][key]?.other_item_name == props.jsonObjKey)
      UpdatedPrice = findBracingObj ? const_var.UpdatedPriceData?.['elements'][findBracingObj].item_price : 0;
    }else{
      UpdatedPrice = 0;
    }
  } else if (props.jsonObj === "extraitems" && const_var?.UpdatedPriceData?.elements?.[props.jsonObjKey] !== undefined) {
    UpdatedPrice = const_var.UpdatedPriceData.elements[props.jsonObjKey]?.item_price;
  } else {
    if (props.jsonIsLeanto !== undefined && const_var?.UpdatedPriceData?.leanto?.length > 0) {
        UpdatedPrice = const_var.UpdatedPriceData.leanto[props.jsonObjIndex]?.[props.jsonObjKey];
    } else {
      if (props.jsonObjKey !== undefined && const_var?.order_extra_items?.[props.jsonObjKey] !== undefined) {
        UpdatedPrice = const_var.order_extra_items[props.jsonObjKey];
      } else {
        UpdatedPrice = const_var?.UpdatedPriceData?.[props.jsonObjKey];
      }
    }
  }


  if(props.componentPrice!=undefined && props.componentPrice=="true")
  {
      UpdatedPrice = props.jsonObj;//const_var.UpdatedPriceData.entry_points[props.jsonObjKey];
  }

  if(props.cupolaPrice!=undefined && props.cupolaPrice=="true")
  {
      UpdatedPrice = props.jsonObj;
  }

  if(props.is_priceChanged!=undefined && props.is_priceChanged=="false")
  {
    UpdatedPrice = props.jsonObjKey;
  }

  UpdatedPrice = UpdatedPrice !== undefined && UpdatedPrice % 1 !== 0 ? Number(UpdatedPrice): UpdatedPrice ;
  let disabledCheck = (props.is_disabled!=undefined && props.is_disabled=="true")?props.is_disabled:"false";
  if(const_var.crmSetting.is_quote_Edit==true)
  {
    disabledCheck = "true";
  }

  if(props.onChangeFnNew != undefined && props.onChangeFnNew == true){
    UpdatedPrice = props.jsonNewObj != undefined ? props.jsonNewObj : 0
  }

  if(props.jsonObjKey == "certificate_price"){
      UpdatedPrice = props.jsonObj
  }

  const updatePrice = (e) => {
    if(props.onChangeFnNew != undefined && props.onChangeFnNew == true) {
      props.onchangeFn(e,'engineer_drawings', 'yes')
    } else {
      if(const_var.crmSetting.is_Edit && const_var.selectedLeanType !=''){
          if(const_var.LNTCrossBracing && const_var.LNTCrossBracing[const_var.selectedLeanType] && const_var.LNTCrossBracing[const_var.selectedLeanType][props.jsonObjKey]){
            const_var.LNTCrossBracing[const_var.selectedLeanType][props.jsonObjKey] = undefined
          }
      }
      dispatch(updatePriceCalculation(e.target.value,props.jsonObj,props.jsonObjKey,props.jsonIsLeanto,props.jsonObjIndex,props.uniqueId, props.elementObjIndex, props.extraItemType, props.cupolaId, props.anchor))
    }
  }
  
  return (
    <div className={"edit-price-wrapper" + (!const_var.is_price_edit ? ' disable-edit' : '')}>
      <span className={const_var.is_loader==true?"active saving-effect saving-effect-type-2 border-radius-none":"saving-effect saving-effect-type-2"}><span></span><span></span><span></span></span>  
      <CurrencyFormat className={((disabledCheck=="true"))?(const_var.is_price_edit ? "no-cursor component-input" : "no-cursor component-input component-input-after"):(const_var.is_price_edit ?"component-input" : "component-input component-input-after")} customInput={TextField} 
        inputMode="numeric"
        maxLength="9"
        allowNegative={false}
        value={(UpdatedPrice==undefined)?0:UpdatedPrice}
        onChange={updatePrice} 
        thousandSeparator={true}  
      />
    </div>
  )

}

export default EditPriceItem